export interface IFiltersData {
  id: string;
  title: string;
  value: string;
}

export const filtersData: Array<IFiltersData> = [
  {id: '1', title: 'جدیدترین', value: 'lastest'},
  {id: '2', title: 'پربازدیدترین', value: 'most_viewed'},
  {id: '3', title: 'نزدیک ترین ', value: 'nearest'},
  {id: '4', title: 'بالاترین امتیاز', value: 'top_rank'},
];

export const newFiltersData: Array<IFiltersData> = [
  {id: '1', title: 'جدیدترین', value: 'created_at'},
  {id: '2', title: 'پربازدیدترین', value: 'view_count'},
  {id: '3', title: 'نزدیک ترین ', value: 'distance'},
  {id: '4', title: 'محبوب ترین', value: 'average_rate'},
];

export const multiSelectData: Array<IFiltersData> = [
  {id: '1', title: ' دارای تخفیف', value: 'has_discount'},
  {
    id: '2',
    title: 'دارای مراجعه حضوری',
    value: 'in_person_possibility',
  },
  {
    id: '3',
    title: 'دارای امکان ارسال مرسوله',
    value: 'has_delivery',
  },
  {
    id: '4',
    title: 'دارای ضمانت کیفیت محصول/ خدمت',
    value: 'has_guarantee',
  },
];
